

const RiskSkeleton = () => {
  return (
   <div className="bg-[#FDFDFD] rounded-2xl shadow w-full max-w-4xl mx-auto max-h-[65vh] mt-0 2xl:mt-20 overflow-y-auto mb-30">
        {/* Header */}
        <div className="flex justify-center items-center border-b py-3 border-gray-200">
          <div className="h-8 w-64 bg-gray-200 rounded-2xl animate-pulse"></div>
        </div>

        {/* Score Row */}
        <div className="flex items-center justify-between border-b p-4 border-gray-200 gap-4">
          <div className="flex items-center gap-4">
            <div className="h-12 w-24 bg-gray-200 rounded-full animate-pulse"></div>
            <div className="h-6 w-40 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="h-6 w-32 bg-gray-200 rounded animate-pulse"></div>
        </div>

        {/* Table Header */}
        <div className="w-full p-4 border-b border-gray-200 text-sm text-gray-400">
          <div className="flex justify-between w-[32vw] 2xl:w-[20vw]">
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-2 gap-4">
          {/* Left column */}
          <div className="col-span-1 border-r border-gray-300 px-0.5 max-h-[55vh] overflow-y-auto">
            {" "}
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="flex justify-between items-center py-3 px-2 border-b border-gray-300"
              >
                <div>
                  <div className="h-4 w-32 bg-gray-200 rounded animate-pulse mb-1"></div>
                  <div className="h-3 w-20 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div className="h-6 w-10 bg-gray-200 rounded-full animate-pulse mr-8"></div>
              </div>
            ))}
          </div>

          {/* Right column */}
          <div className="col-span-1 p-4 max-h-[55vh] overflow-y-auto">
            <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse mb-3"></div>
            <div className="border border-gray-200 rounded-xl p-2 mb-4">
              <div className="flex justify-between items-center text-sm pb-2">
                <div>
                  <div className="h-3 w-12 bg-gray-200 rounded animate-pulse mb-1"></div>
                  <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                </div>
                <div>
                  <div className="h-3 w-12 bg-gray-200 rounded animate-pulse mb-1"></div>
                  <div className="h-4 w-6 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </div>
              <div className="border-t border-gray-300 pt-2">
                <div className="h-3 w-28 bg-gray-200 rounded animate-pulse mx-auto"></div>
              </div>
            </div>

            {[...Array(2)].map((_, i) => (
              <div key={i} className="mb-4">
                <div className="h-4 w-40 bg-gray-200 rounded animate-pulse mb-2"></div>
                <div className="border border-gray-200 rounded-xl p-3 my-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="h-3 w-16 bg-gray-200 rounded animate-pulse mb-1"></div>
                      <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div>
                      <div className="h-3 w-16 bg-gray-200 rounded animate-pulse mb-1"></div>
                      <div className="h-4 w-12 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                  </div>
                </div>
                <div className="h-3 w-3/4 bg-gray-200 rounded animate-pulse mb-2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
  )
}

export default RiskSkeleton
